<template>
    <div class="department-table-box">
        <el-input
            v-model="search"
            size="small"
            class="table-search"
            @keyup.native.enter="handleSearch(search)"
            @input="handleInput"
            :placeholder="$t('public.keyWord')"
            clearable>
        </el-input>
        <el-table
            :data="department_list"
            height="300"
            :default-sort="{prop: propAttr, order: order}"
            tooltip-effect="dark"
            @sort-change="handleTableSort"
            @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="44">
            </el-table-column>
            <!-- 分行/分公司 -->
            <el-table-column
                :label="$t('message.cdepartment.table1')"
                prop="parentname"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 部門編號 -->
            <el-table-column
                :label="$t('message.cdepartment.table2')"
                prop="department_code"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 部門名稱（中文） -->
            <el-table-column
                :label="$t('message.cdepartment.table3')"
                prop="departmentname"
                align="center"
                sortable="custom"
                show-overflow-tooltip
                width='150'>
            </el-table-column>
            <!-- 部門名稱（英文） -->
            <el-table-column
                :label="$t('message.cdepartment.table4')"
                prop="en_departmentname"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
			<!-- 可分配金額 -->
			<el-table-column
			    :label="$t('message.cdepartment.table6')"
			    prop="amount"
			    align="center"
			    sortable="custom"
			    show-overflow-tooltip>
			</el-table-column>
            <!-- 操作 -->
            <el-table-column
                :label="$t('message.cdepartment.table5')"
                align="center"
                width="150">
                <template v-slot="{row}">
                    <el-button
                        type="primary"
                        size="mini"
                        @click="handleModify(row.department_id)">
                        <span>{{$t("public.modifyBtn")}}</span>
                    </el-button>
                    <el-button
                        type="danger"
                        size="mini"
                        @click="handleDel(row.department_id)">
                        <span>{{$t("public.delBtn")}}</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
       <table-pagination
            :current-page="currentPage"
            :page-count="pageCount"
            :need-del="true"
            @current-change="handleCurrent"
            @handle-del="handleBatchDel">
        </table-pagination>
		<div style="padding: 10px; display: flex;justify-content: flex-end;">
			<el-pagination
			  @current-change="handleCurrent"
			  :current-page.sync="currentPage2"
			  :page-size="page.per_page"
			  layout="prev, pager, next, jumper"
			  :total="page.total"
			  background>
			</el-pagination>
		</div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { tableSortHandle } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableSortHandle ],
    computed: mapState({
        department_list: state => state.user.department_list,
		page: state => state.user.page
    }),
	data() {
		return {
			currentPage2:0,
		}
	},
	watch:{
		currentPage(){
			this.currentPage2 = this.currentPage
		}
	},
    methods: {
        ...mapActions([
            "handleDelDepartment"
        ]),
        handleDel(id){ // 删除按钮
            this.$confirm(this.$t("message.cdepartment.isDel"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning'
            }).then(this.handleDelDepartment(id))
            .then(res => {
                this.$emit('handleDelete', res)
            }).catch(err => {
                console.log(err)
            })
        }
    }
}
</script>

<style scoped>
.department-table-box{
    background: #fff;
}
.table-search{
    width: 200px;
    margin: 10px;
}
</style>
